export const isLoading = (state) => state.loading

export const isLoadingStaff = (state) => state.staff.loading

export const getShowOrgaTree = (state) => state.showOrgaTree

export const getData = (state) => state.data

export const getDataResearchProject = (state) => state.data.forschungsprojekt

export const getDataPublication = (state) => state.data.publikation

export const getSchema = (state) => state.listSchema

export const getSelected = (state) => state.selected

export const getStaffStartsWithData = (state) => state.staff.data

export const getStaffStartsWith = (state) => state.staff.startsWith

export const getStaffFullName = (state) => state.staff.fullName

export const getStaffLetterCount = (state) => state.staff.letterCount

export const getStaffTotalEntries = (state) => state.staff.totalEntries

export const getResourceType = (state) => state.resourceType

export const getConfig = (state) => state.config

export const getTotal = (state) => state.total

export const getActiveTab = (state) => state.activeTab

export const getId = (state) => state.id

export const getFilter = (state) => state.filter

export const resourceTypes = (state) => state.resourceTypes

export const getLabel = (state) => state.label

export const getPage = (state) => state.config[state.resourceType].page

export const getPerPage = (state) => state.config[state.resourceType].perPage

export const getSortField = (state) => state.config[state.resourceType].sortField

export const getSortOrder = (state) => state.config[state.resourceType].sortOrder

export const getLeurisProfile = (state) => state.leurisProfile.data

export const getLeurisProfileFisPersid = (state) => state.leurisProfile.fisPersid

export const getORCID = (state) => state.leurisProfile.orcid

export const getUlWebsiteProfile = (state) => state.leurisProfile.ulWebsiteProfile

export const getOuDescription = (state) => state.ouDetails.description

export const getOuDetails = (state) => state.ouDetails

export const getRootQueryType = (state) => state.selected.rootQueryType



// WEBPACK FOOTER //
// ./src/store/modules/publicView/getters.js